import React from 'react'

import { ScrollView, StyleSheet } from 'react-native'

import { Title, Text, Space } from '@sart/components'
import { adaptive, colors } from '@sart/styles'

export default function Preferences(props) {
  const { navigation } = props

  return (
    <ScrollView contentContainerStyle={styles.wrapper}>

    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  }
})
